(function () {
  'use strict';

  function parseVariants(card) {
    var el = card.querySelector('[data-am-card-variants]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function selectedColor(card) {
    var checked = card.querySelector('[data-swatches-container] input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  function resolveVariantId(card, btn) {
    var variants = parseVariants(card);
    var color = selectedColor(card);
    if (color && variants.length) {
      var onlyOneOption = variants.every(function (v) {
        return !v.options || v.options.length <= 1;
      });
      if (onlyOneOption || variants.every(function (v) {
        return (v.options || []).length === 1;
      })) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (!v.available) continue;
          if ((v.options || [])[0] === color) return String(v.id);
        }
      }
    }
    return btn.getAttribute('data-variant-id');
  }

  function canDirectAdd(card, btn) {
    if (btn.hasAttribute('data-quick-buy')) return true;
    if (!btn.hasAttribute('data-quickshop-slim')) return false;
    var variants = parseVariants(card);
    if (!variants.length) return false;
    var multi = variants.some(function (v) {
      return (v.options || []).length > 1;
    });
    if (multi) return false;
    return !!selectedColor(card);
  }

  function updateSelectedLabel(card) {
    var label = card.querySelector('[data-am-swatch-selected]');
    if (!label) return;
    var color = selectedColor(card);
    label.textContent = color ? ('Color: ' + color) : '';
  }

  function addToCart(variantId, btn) {
    var routes = (window.Theme && window.Theme.routes) || {};
    var addUrl = (routes.cart_add_url || '/cart/add') + '.js';
    var cartUrl = (routes.cart_url || '/cart') + '.js';
    btn && btn.classList.add('is-loading');
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function () {
        return fetch(cartUrl, {
          method: 'GET',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
      })
      .finally(function () {
        btn && btn.classList.remove('is-loading');
      });
  }

  function onDocClick(e) {
    var btn = e.target.closest('[data-quick-buy], [data-quickshop-slim]');
    if (!btn) return;
    var card = btn.closest('[data-product-item]');
    if (!card) return;
    if (!canDirectAdd(card, btn)) return;

    var variantId = resolveVariantId(card, btn);
    if (!variantId) return;
    // Color-only ATC: use selected swatch variant; qty always 1 (Empire default).
    e.preventDefault();
    e.stopImmediatePropagation();
    addToCart(variantId, btn).catch(function (err) {
      console.warn('AM quick-add failed', err);
      window.alert((err && (err.description || err.message)) || 'Could not add to cart');
    });
  }

  function enhanceCard(card) {
    if (card.getAttribute('data-am-quickadd-ready')) return;
    if (!card.querySelector('[data-product-actions]')) return;
    card.setAttribute('data-am-quickadd-ready', '1');
    updateSelectedLabel(card);
    var swatches = card.querySelector('[data-swatches-container]');
    if (swatches) {
      swatches.addEventListener('change', function () {
        updateSelectedLabel(card);
      });
    }
  }

  function scan() {
    document.querySelectorAll('[data-product-item]').forEach(enhanceCard);
  }

  document.addEventListener('click', onDocClick, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
  var mo = new MutationObserver(function () {
    scan();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
